<app-print-layout-matDialog (imprimir)="onImprimir()" (fechar)="onFechar()" [retrato]="true"
    titulo="Imprimir Relatoria">

    <div class="card-body">

        <div *ngIf="minuta" class="watermark">MINUTA</div>

        <div>
            <div class="row mb-1">
                <div class="col-md-12" style="font-weight: bold; font-size: 18pt; text-align: center;">
                    RELATÓRIO DE MONITORAMENTO - OSA Nº {{model?.osaExecucao?.osa?.numero}}
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12" style="padding-top: 15px;">
                    <table class="table" style="border: 1px solid #ccc; border-collapse: collapse; width: auto;">
                        <thead>
                            <tr>
                                <td [attr.colspan]="4"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Unidade Auditada: </strong> <br> {{model.unidadeGestora?.codigoUg}} -
                                    {{model.unidadeGestora?.nome}} / {{model.unidadeGestora?.sigla}}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Responsável: </strong> <br> {{model.unidadeGestora?.nomeResponsavel}}
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="4"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Objeto Auditado: </strong> <br>
                                    {{model?.osaExecucao?.osa?.planejamento?.opa?.objeto}}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Data de Elaboração: </strong> <br> {{ model?.dataFinalizacao |
                                    date:'dd/MM/yyyy' }}
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Nº do Doc. <br> Associado: </strong> <br> OSA
                                    {{model?.osaExecucao?.osa?.numero}}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Referência: </strong> <br> {{ model?.tipo?.descricao }}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Tipo: </strong> <br> {{ model?.osaExecucao?.osa?.planejamento &&
                                    model?.osaExecucao.osa.planejamento?.opa?.tipoAuditoria?.nome }}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Status do Plano de <br> Ação: </strong> <br> {{ model?.status?.descricao }}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Prazo Final de <br> Implementação: </strong> <br> {{ model?.prazoFinal |
                                    date:'dd/MM/yyyy' }}
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc; padding: 0; height:50px;">
                                    <div class="bg-cell">
                                        <strong> RESUMO DO RESULTADO DO MONITORAMENTO </strong>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong> Nº total de ações <br> planejadas: </strong>
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{ model?.numTotalAcaoPlanejada }}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong> STATUS DAS AÇÕES </strong>
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong> Nº total de ações por <br> status: </strong>
                                </td>
                                <td [attr.colspan]="1" [attr.rowspan]="4"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong> Percentual de <br> Implementação do Plano <br> com base nos Status e Nível
                                        <br> de Relevância das ações: </strong>
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1" [attr.rowspan]="3"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong> Ações planejadas POR NÍVEL <br> DE RELEVÂNCIA: </strong>
                                </td>
                                <td [attr.colspan]="1" [attr.rowspan]="3"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong> Nº total <br> de Ações </strong>
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    Atendida
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusAtendidaQtde}}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    Atendida Parcialmente
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusAtendidaParcialmenteQtde}}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    Não Atendida
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusNaoAtendidaQtde}}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    1 - Muito Baixa
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{relevanciaMuitoBaixaQtde}}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    Pendente de Ação de Controle
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusPendenteAcaoControleQtde}}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong>{{model?.percentualImplementacao}} %</strong>
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    2 - Baixa
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{relevanciaBaixaQtde}}
                                </td>
                                
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    A ser Realizada
                                </td>

                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusASerRealizadaQtde}}
                                </td>
                                <td [attr.colspan]="1" [attr.rowspan]="2"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    <strong>Avaliação Final quanto <br> atendimento:</strong>
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    3 - Moderada
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{relevanciaModeradaQtde}}
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    Em Execução
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusEmExecucaoQtde}}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    4 - Alta
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{relevanciaAltaQtde}}
                                </td>
                                <td [attr.colspan]="1" [attr.rowspan]="2"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    Concluida
                                </td>
                                <td [attr.colspan]="1" [attr.rowspan]="2"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{statusConcluidaQtde}}
                                </td>
                                <td [attr.colspan]="1" [attr.rowspan]="2"
                                    [ngClass]="getClasseAvaliacao(model?.avaliacaoFinal?.codigo)"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc; text-transform: uppercase;">
                                    <strong>{{ model?.avaliacaoFinal?.descricao | uppercase }}</strong>
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    5 - Muito Alta
                                </td>
                                <td [attr.colspan]="1"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                    {{relevanciaMuitoAltaQtde}}
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: center; vertical-align: middle; border: 1px solid #ccc; padding: 0; height:50px;">
                                    <div class="bg-cell">
                                        <strong> DETALHAMENTO DAS AÇÕES PLANEJADAS </strong>
                                    </div>
                                </td>
                            </tr>

                        </thead>
                        <tbody>

                            <ng-container *ngFor="let item of model.acoes">
                                <tr>
                                    <td [attr.colspan]="1" class="td-bg-cell-acoes"
                                        style="text-align: left; vertical-align: top;">
                                        <strong> Ação:</strong> <br> {{ item.identificador }}
                                    </td>

                                    <td [attr.colspan]="1" class="td-bg-cell-acoes"
                                        style="text-align: left; vertical-align: top;">
                                        <strong> Status da Ação: </strong> <br> {{ item.status.descricao }}
                                    </td>

                                    <td [attr.colspan]="2" class="td-bg-cell-acoes"
                                        style="text-align: left; vertical-align: top;">
                                        <strong> Responsável: </strong> <br>
                                        <span [innerHTML]="item.responsavelNome"> </span>
                                    </td>

                                    <td [attr.colspan]="1" class="td-bg-cell-acoes"
                                        style="text-align: center; vertical-align: top;">
                                        <strong> Prazo de Implementação: </strong> <br> {{item.prazo |
                                        date:'dd/MM/yyyy'}}
                                    </td>
                                </tr>


                                <tr>
                                    <td [attr.colspan]="5"
                                        style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                        <strong> Título da Ação: </strong> <br> {{item.titulo }}
                                    </td>
                                </tr>
                                <tr>
                                    <td [attr.colspan]="5"
                                        style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                        <strong> Descrição da Ação: </strong> <br>
                                        <span [innerHTML]="item.descricao"> </span>
                                    </td>
                                </tr>

                                <tr>
                                    <td [attr.colspan]="5"
                                        style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                        <strong> Recomendações Vinculadas: </strong> <br>
                                        <ng-container *ngFor="let r of item.recomendacoes">
                                <tr>
                                    <td style="border:none; padding-left: 0px; padding-top: 0px; padding-bottom: 0px;">
                                        <strong>{{ r.recomendacao.titulo }} - </strong> {{ r.recomendacao.descricao }}
                                    </td>
                                </tr>
                            </ng-container>
                            </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="3"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Avaliação da Ação pelo Auditor: </strong> {{ item.avaliacao?.descricao }}
                                </td>
                                <td [attr.colspan]="2"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Nível de Relevância da Ação: </strong> {{ item.nivelRelevancia?.descricao
                                    }}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Justificativa da Avaliação pelo Auditor: </strong> <br> {{
                                    item?.justificativaAvaliacao }}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Manifestação do Auditado: </strong> <br> {{ item?.comentarioAuditor }}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="4"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Descrição da Implementação da Ação: </strong> <br>
                                    <span [innerHTML]="item?.descricaoImplementacao"> </span>
                                </td>

                                <td [attr.colspan]="1"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Data de Realização: </strong> <br> {{ item?.dataRealizacao |
                                    date:'dd/MM/yyyy' }}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Lista de Evidências de Implementação da Ação: </strong> <br>
                                    <ng-container *ngFor="let e of item.evidencias">
                            <tr>
                                <td style="border:none; padding-left: 0px; padding-top: 0px; padding-bottom: 0px;">
                                    {{ e.nome }}
                                </td>
                            </tr>
                            </ng-container>
                            </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="3"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Avaliação da Implementação pelo Auditor: </strong> {{ item?.descricaoImplementacaoAuditor ? item.status?.descricao : '' }}
                                </td>
                                <td [attr.colspan]="2"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Data do Monitoramento: </strong> {{ item?.dataMonitoramento |
                                    date:'dd/MM/yyyy' }}
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Descrição da Avaliação da Implementação pelo Auditor: </strong> <br>
                                    <span [innerHTML]="item?.descricaoImplementacaoAuditor"> </span>
                                </td>
                            </tr>

                            <tr>
                                <td [attr.colspan]="5"
                                    style="text-align: left; vertical-align: top; border: 1px solid #ccc;">
                                    <strong> Lista de Evidências da Avaliação da Implementação pelo Auditor: </strong>
                                    <br>
                                    <ng-container *ngFor="let ea of item.evidenciasAuditor">
                            <tr>
                                <td style="border:none; padding-left: 0px; padding-top: 0px; padding-bottom: 0px;">
                                    {{ ea.nome }}
                                </td>
                            </tr>
                            </ng-container>
                            </td>
                            </tr>

                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-12">
                <div>Data da Impressão: <strong> {{ dataHoje | date:'dd/MM/yyyy' }} </strong> </div>
                <div style="height: 5px;"></div>
                <div><strong>Monitoramento:</strong> </div>
                <table style="width: 100%; border-collapse: collapse; margin-top: 1px; border: none;"
                    *ngIf="monitores && monitores.length > 0">
                    <thead>
                        <tr>
                            <th style="border: none; padding: 0px; text-align: left; font-weight: normal;">
                                Nome
                            </th>
                            <th style="border: none; padding: 0px; text-align: left; font-weight: normal;">
                                Cargo do Servidor
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let monitor of monitores">
                            <td style="border: none; padding: 0px;">
                                {{ monitor.responsavelNomeMonitoramento }}
                            </td>
                            <td style="border: none; padding: 0px;">
                                {{ monitor.responsavelCargoMonitoramento }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</app-print-layout-matDialog>